import React, { useState } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, fetchSignInMethodsForEmail } from 'firebase/auth';
import { auth, db } from './firebase';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, updateDoc, doc, addDoc } from 'firebase/firestore';

import Header from './components/Header';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [checkingEmail, setCheckingEmail] = useState(false);
  const [bobmcUser, setBobmcUser] = useState(null);
  const [showCreateAccount, setShowCreateAccount] = useState(false);
  const [showPasswordField, setShowPasswordField] = useState(false);
  const [showNextField, setShowNextField] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  const navigate = useNavigate();

  // Check if user is logged in
  React.useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user);
    });
    return () => unsubscribe();
  }, []);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard');
    } catch (error) {
      if (error.code === 'auth/user-not-found') {
        // Check if user exists in bobmc_user
        } else {
        setError('Failed to login: ' + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCreateAccount = async () => {
    setError('');
    setLoading(true);
    
    try {
      // Create new user
      const tempPassword = Math.random().toString(36).slice(-8);
      await createUserWithEmailAndPassword(auth, email, tempPassword);
       // Update bobmc_user with role

      // Send password reset email
      await sendPasswordResetEmail(auth, email);
      
      setError('');
      alert('Account created!');
      
    } catch (error) {
      setError('Failed to create account: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center landing">
      
       <div className="row ">
         <Header title="Login"
         showBack={false}
         showDashboard={false}
         showSignOut={false}
         />
         <div className="col">
         
          <div className="card">
            <div className="card-body">
     
              {error && (
                <div className={`alert ${showCreateAccount ? 'alert-info' : 'alert-danger'}`}>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                   
                  />
                   
                
                   </div>
               
              
                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={loading}
                      autoFocus
                    />
                 
                  </div>
            

             
                  
               
                
                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? 'Logging in...' : 'Login'}
                    </button>
                      {/* Add Forgot Password link */}
                      <div className="d-grid gap-2">
                  
                          {currentUser && (
                            <button
                              type="button"
                              className="btn btn-link"
                              onClick={handleCreateAccount}
                              disabled={loading}
                            >
                              {loading ? 'Creating Account...' : 'Create Account'}
                            </button>
                          )}

                            <button
                              type="button"
                              className="btn btn-link"
                              onClick={async () => {
                                 try {
                                        await sendPasswordResetEmail(auth, email);
                                        setError('Password reset email sent! Please check your inbox.');
                                      } catch (err) {
                                        setError('Failed to send password reset email: ' + err.message);
                                      }
                                      setShowPasswordField(true);
                              }}
                            >
                              Forgot Password?
                            </button>
                  
                   
                  </div>
                  
                  </div>
                
              </form>

            
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
}
